<template>
  <div>
    <v-progress-linear v-if="cargando" indeterminate color="purple" class="mb-2" />

    <ag-grid-vue
      :gridOptions="gridOptions"
      class="ag-theme-balham ag-grid-table-estimaciones"
      :columnDefs="columnDefs"
      :defaultColDef="defaultColDef"
      @grid-ready="onGridReady"
      :rowData="items"
      rowSelection="multiple"
      :isRowSelectable="isRowSelectable"
      colResizeDefault="shift"
      :animateRows="false"
      :floatingFilter="false"
      :pagination="false"
      :rowClassRules="rowClassRules"
      @selection-changed="onSelectionChanged"
      @first-data-rendered="onFirstDataRendered"
      :pinnedBottomRowData="pinnedBottomRowData"
      :alwaysShowVerticalScroll="true"
      :suppressPaginationPanel="true">
    </ag-grid-vue>
  </div>
</template>

<script>
import ListadoAgGridMixin from '../mixins/listado-ag-grid-mixin';
import {
  aMonedaValueFormatter,
  cellRendererNumeroRegistro,
  ESTADOS_DETALLE_TRANSACCION,
  formatearValorAMoneda,
} from '../utils';
import CabeceraDetalleGestion from '../components/CabeceraDetalleGestion.vue';
import CabeceraAgGridPersonalizada from '../components/CabeceraAgGridPersonalizada.vue';

export default {
  name: 'ListadoPresupuestoEstimacionIngreso',
  mixins: [ListadoAgGridMixin],
  components: {
    // eslint-disable-next-line vue/no-unused-components
    CabeceraDetalleGestion,
    // eslint-disable-next-line vue/no-unused-components
    CabeceraAgGridPersonalizada,
  },
  props: {
    gestion: {
      type: Object,
      default: null,
    },
  },
  watch: {
    gestion: {
      handler: function () {
        this.gridApi?.refreshHeader();
      },
      deep: true,
      inmediate: true,
    },
  },
  data() {
    return {
      isRowSelectable: false,
      columnDefs: [
        {
          headerName: 'NRO. REG.',
          cellRenderer: cellRendererNumeroRegistro,
          filter: false,
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: true,
          minWidth: 120,
          maxWidth: 120,
        },
        {
          headerName: 'ESTADO',
          cellRenderer: (params) => {
            if (params.node.rowPinned) {
              return undefined;
            } else {
              const clase =
                params.data.estado == ESTADOS_DETALLE_TRANSACCION.PENDIENTE
                  ? 'pill-warning'
                  : params.data.estado == ESTADOS_DETALLE_TRANSACCION.ACEPTADO
                  ? 'pill-success'
                  : 'pill-danger';

              return /*html*/ `<div class="pill ${clase}">${params.data.estado}</div>`;
            }
          },
          minWidth: 120,
          maxWidth: 120,
        },
        {
          headerName: 'NOMBRE DEL PROGRAMA',
          field: 'nombre_programa',
          filter: false,
          minWidth: 300,
        },
        {
          headerName: 'CATEGORIA  ',
          field: 'categoria',
          filter: false,
          minWidth: 200,
        },

        {
          headerComponent: 'CabeceraDetalleGestion',
          headerComponentParams: () => {
            return {
              gestion: this.gestion,
            };
          },
          cellRenderer: (params) => {
            if (params.node.rowPinned) {
              return undefined;
            } else {
              const data = params.data;
              let detalle = /*html*/ `<table width="100%" style="border-collapse: collapse;">`;

              for (let index = 0; index < params.data.detalles_estimaciones.length; index++) {
                const detalleEstimacion = params.data.detalles_estimaciones[index];
                detalle += /*html*/ `<tr>
                    <td style="width: 300px; max-width: 300px; overflow-x: hidden;">
                        ${detalleEstimacion.clasificador_nombre}
                    </td>
                    <td style="width: 100px; text-align: right;">
                      ${formatearValorAMoneda(detalleEstimacion.costo)}
                    </td>
                    <td style="width: 100px; text-align: right;">
                      ${formatearValorAMoneda(detalleEstimacion.subtotal)}
                    </td>
                    <td style="width: 100px; text-align: right;">
                      ${formatearValorAMoneda(detalleEstimacion.desercion)}
                    </td>
                    <td style="width: 100px; text-align: right;">
                      ${formatearValorAMoneda(detalleEstimacion.total)}
                    </td>
                    <td style="width: 100px; text-align: right;">
                      ${formatearValorAMoneda(detalleEstimacion.subtotal_gestion)}
                    </td>
                    <td style="width: 100px; text-align: right;">
                      ${formatearValorAMoneda(detalleEstimacion.desercion_gestion)}
                    </td>
                    <td style="width: 100px; text-align: right;">
                      ${formatearValorAMoneda(detalleEstimacion.total_gestion)}
                    </td>
                </tr>`;
              }

              detalle += /*html*/ `

            <tr>
                <td colspan="4" style="text-align: right; font-weight: 600;">
                  TOTAL PROGRAMA
                </td>
                <td style="text-align: right; font-weight: 600;">
                  ${formatearValorAMoneda(data.total)}
                </td>
                <td colspan="2" style="text-align: right; font-weight: 600;">
                  TOTAL ${this.gestion?.numero}
                </td>
                <td style="text-align: right; font-weight: 600;">
                  ${formatearValorAMoneda(data.total_gestion)}
                </td>
            </tr>
            </table>`;

              return detalle;
            }
          },
          autoHeight: true,
          suppressSizeToFit: true,
          filter: false,
          minWidth: 1200,
          maxWidth: 1200,
        },
        {
          headerName: 'CANT. PERSONAS',
          field: 'cantidad_inscritos_estimada',
          type: 'numericColumn',
          filter: false,
          minWidth: 140,
          maxWidth: 140,
        },
        {
          headerName: 'NRO CUOTAS',
          field: 'numero_cuotas',
          type: 'numericColumn',
          filter: false,
          minWidth: 100,
          maxWidth: 100,
        },
        {
          headerName: 'FECHA INICIO',
          field: 'fecha_inicio',
          filter: false,
          minWidth: 120,
          maxWidth: 120,
        },
        {
          headerName: 'FECHA SEGUNDA',
          field: 'fecha_segunda',
          filter: false,
          minWidth: 120,
          maxWidth: 120,
        },
        {
          headerName: 'FECHA FIN',
          field: 'fecha_fin',
          filter: false,
          minWidth: 120,
          maxWidth: 120,
        },
        {
          headerName: 'TASA DESERCIÓN(%)',
          field: 'tasa_desercion',
          type: 'numericColumn',
          valueFormatter: aMonedaValueFormatter,
          filter: false,
          minWidth: 150,
          maxWidth: 150,
        },
        {
          headerName: 'TOTAL',
          field: 'total',
          type: 'numericColumn',
          valueFormatter: aMonedaValueFormatter,
          filter: false,
          minWidth: 120,
          maxWidth: 120,
        },
        {
          headerComponent: 'CabeceraAgGridPersonalizada',
          headerComponentParams: () => {
            return {
              contenido: `TOTAL(${this.gestion?.numero})`,
            };
          },
          field: 'total_gestion',
          type: 'numericColumn',
          valueFormatter: aMonedaValueFormatter,
          filter: false,
          minWidth: 120,
          maxWidth: 120,
        },
      ],
    };
  },
  computed: {
    pinnedBottomRowData() {
      return [
        {
          nombre_programa: 'TOTAL',
          total: this.sumatoria('total'),
          total_gestion: this.sumatoria('total_gestion'),
          bold: true,
        },
      ];
    },
  },
  created: function () {
    this.getRowStyle = (params) => {
      if (params.node.rowPinned) {
        if (params.node.data.bold) {
          return { 'font-weight': 'bold' };
        }
      }
    };
    this.isRowSelectable = (params) => {
      return !!params.data;
    };
  },
  methods: {
    onSelectionChanged() {
      this.selectedRows = this.gridApi.getSelectedRows();
      this.$emit('selectItem', this.selectedRows.length > 0 ? this.selectedRows : null);
    },
    sumatoria(key) {
      if (key != 'total' && key != 'total_gestion') {
        return 0;
      }

      let sumatoria = 0;

      for (let index = 0; index < this.items.length; index++) {
        sumatoria = sumatoria + parseFloat(this.items[index][key]);
      }

      sumatoria = sumatoria.toFixed(2);

      return formatearValorAMoneda(sumatoria);
    },
  },
};
</script>

<style>
@import '~ag-grid-community/dist/styles/ag-grid.css';
@import '~ag-grid-community/dist/styles/ag-theme-balham.css';

.ag-grid-table-estimaciones {
  height: calc(var(--vh, 1vh) * 100 - 17rem);
}

.ag-cell:nth-child(3) .ag-cell-wrapper {
  display: block;
}

.pill {
  display: inline-block;
  margin: 0.5rem 0;
  border-radius: 10px;
  padding: 0 0.75rem;
  line-height: 20px;
  text-align: center;
  font-size: 0.725rem;
  font-weight: 700;
  font-family: Roboto, sans-serif;
  border-width: 1px;
  border-style: solid;
}

.pill-warning {
  border-color: #ff9800;
  color: #ff9800;
}

.pill-success {
  border-color: #4caf50;
  color: #4caf50;
}

.pill-danger {
  border-color: #f44336;
  color: #f44336;
}
</style>
